import React from 'react';
import Panel from '../panel/panel';

const PanelOperador = (props) => (
  <Panel>
    <div className='row'>
      <div className='col-lg-5 col-md-6 col-xs-12'>
        <table className='datos info-proveedor' width='100%'>
          <tbody>
            <tr>
              {/* <th width="125px">
                Operador Responsable:
              </th>
              <th className="logo-prov" align="left">
                <img src={ props.datos.logourl } width="150px" alt="logo" className="center-block"/>
              </th> */}
              <th>
                <table>
                  <tbody>
                    {/* <tr>
                      <th>Nombre: </th>
                      <th style={ { paddingLeft: 10 } }>CUIT:</th>
                    </tr> */}
                    <tr>
                      <th style={{ fontWeight: 400 }}>
                        Operador:
                        {props.datos.nombre}
                      </th>
                      {/* <th style={ { paddingLeft: 10 } }><span style={ { fontWeight: 400 } }>{props.datos.cuit}</span></th> */}
                    </tr>
                  </tbody>
                </table>
              </th>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </Panel>
);

export default PanelOperador;
